/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_SourceInputs */

const en_ui_onboarding_ask_source = /** @type {(inputs: Ui_Onboarding_Ask_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 · Where your sessions come from`)
};

const de_ui_onboarding_ask_source = /** @type {(inputs: Ui_Onboarding_Ask_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 · Woher deine Einheiten kommen`)
};

/**
* | output |
* | --- |
* | "1 · Where your sessions come from" |
*
* @param {Ui_Onboarding_Ask_SourceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_source = /** @type {((inputs?: Ui_Onboarding_Ask_SourceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_SourceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_source(inputs)
	return de_ui_onboarding_ask_source(inputs)
});